/**
 * Do not edit directly
 * Generated on Thu, 10 Aug 2023 10:25:09 GMT
 */

export const BACKGROUND_STATIC_FLAT = "hsl(240, 18%, 9%)";
export const BACKGROUND_STATIC_RAISED = "hsl(240, 17%, 10%)";
export const BACKGROUND_STATIC_FLOATING = "hsl(240, 16%, 12%)";
export const BACKGROUND_STATIC_SUNKEN = "hsl(0, 0%, 0%)";
export const BACKGROUND_STATIC_INVERSE = "hsl(0, 0%, 100%)";
export const BACKGROUND_INTERACTIVE_PRIMARY_DEFAULT = "hsl(241, 88%, 72%)";
export const BACKGROUND_INTERACTIVE_PRIMARY_HOVER = "hsl(242, 89%, 83%)";
export const BACKGROUND_INTERACTIVE_PRIMARY_ACTIVE = "hsl(242, 90%, 92%)";
export const BACKGROUND_INTERACTIVE_SECONDARY_DEFAULT = "hsl(241, 100%, 14%)";
export const BACKGROUND_INTERACTIVE_SECONDARY_HOVER = "hsl(241, 96%, 18%)";
export const BACKGROUND_INTERACTIVE_SECONDARY_ACTIVE = "hsl(241, 91%, 26%)";
export const BACKGROUND_INTERACTIVE_DANGER_DEFAULT = "hsl(0, 79%, 64%)";
export const BACKGROUND_INTERACTIVE_DANGER_HOVER = "hsl(0, 84%, 69%)";
export const BACKGROUND_INTERACTIVE_DANGER_ACTIVE = "hsl(0, 85%, 76%)";
export const BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_DEFAULT = "hsl(240, 18%, 9%)";
export const BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_HOVER = "hsl(240, 17%, 10%)";
export const BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_ACTIVE = "hsl(240, 16%, 12%)";
export const BACKGROUND_INTERACTIVE_NEUTRAL_DEFAULT = "hsl(240, 15%, 16%)";
export const BACKGROUND_INTERACTIVE_NEUTRAL_HOVER = "hsl(240, 15%, 23%)";
export const BACKGROUND_INTERACTIVE_NEUTRAL_ACTIVE = "hsl(240, 14%, 30%)";
export const BACKGROUND_INTERACTIVE_NEUTRAL_BOLD_DEFAULT = "hsl(240, 16%, 61%)";
export const BACKGROUND_INTERACTIVE_NEUTRAL_BOLD_HOVER = "hsl(240, 16%, 71%)";
export const BACKGROUND_INTERACTIVE_NEUTRAL_BOLD_ACTIVE = "hsl(240, 17%, 80%)";
export const BACKGROUND_ACCENT_PRIMARY = "hsl(241, 86%, 63%)";
export const BACKGROUND_ACCENT_SECONDARY = "hsl(356, 100%, 47%)";
export const BACKGROUND_ALERT_DANGER_PRIMARY = "hsl(0, 79%, 64%)";
export const BACKGROUND_ALERT_DANGER_SECONDARY = "hsl(0, 70%, 12%)";
export const BACKGROUND_ALERT_WARNING_PRIMARY = "hsl(42, 84%, 53%)";
export const BACKGROUND_ALERT_WARNING_SECONDARY = "hsl(42, 100%, 10%)";
export const BACKGROUND_ALERT_SUCCESS_PRIMARY = "hsl(110, 74%, 71%)";
export const BACKGROUND_ALERT_SUCCESS_SECONDARY = "hsl(109, 46%, 14%)";
export const BACKGROUND_ALERT_INFO_PRIMARY = "hsl(216, 82%, 58%)";
export const BACKGROUND_ALERT_INFO_SECONDARY = "hsl(216, 96%, 18%)";
export const BACKGROUND_ALERT_BASIC_PRIMARY = "hsl(240, 16%, 61%)";
export const BACKGROUND_ALERT_BASIC_SECONDARY = "hsl(240, 15%, 16%)";
export const BACKGROUND_DISABLED = "hsl(240, 15%, 23%)";
export const BACKGROUND_BACKDROP = "hsla(240, 18%, 9%, 0.64)";
export const BACKGROUND_BRAND = "hsl(0, 0%, 100%)";
export const TEXT_STATIC_PRIMARY = "hsl(0, 0%, 100%)";
export const TEXT_STATIC_SECONDARY = "hsl(240, 16%, 71%)";
export const TEXT_STATIC_TERTIARY = "hsl(240, 16%, 61%)";
export const TEXT_STATIC_INVERSE = "hsl(240, 17%, 10%)";
export const TEXT_INTERACTIVE_DEFAULT = "hsl(241, 88%, 72%)";
export const TEXT_INTERACTIVE_HOVER = "hsl(242, 89%, 83%)";
export const TEXT_INTERACTIVE_ACTIVE = "hsl(242, 90%, 92%)";
export const TEXT_ALERT_DANGER = "hsl(0, 85%, 76%)";
export const TEXT_ALERT_WARNING = "hsl(42, 90%, 81%)";
export const TEXT_ALERT_SUCCESS = "hsl(110, 83%, 89%)";
export const TEXT_ALERT_INFO = "hsl(216, 89%, 83%)";
export const TEXT_ALERT_BASIC = "hsl(240, 16%, 71%)";
export const TEXT_DISABLED = "hsl(240, 13%, 45%)";
export const BORDER_STATIC_PRIMARY = "hsl(240, 13%, 45%)";
export const BORDER_STATIC_SECONDARY = "hsl(240, 13%, 53%)";
export const BORDER_STATIC_INVERSE = "hsl(240, 18%, 9%)";
export const BORDER_INTERACTIVE_PRIMARY_DEFAULT = "hsl(241, 88%, 72%)";
export const BORDER_INTERACTIVE_PRIMARY_HOVER = "hsl(242, 89%, 83%)";
export const BORDER_INTERACTIVE_PRIMARY_ACTIVE = "hsl(242, 90%, 92%)";
export const BORDER_INTERACTIVE_SECONDARY_DEFAULT = "hsl(240, 15%, 23%)";
export const BORDER_INTERACTIVE_SECONDARY_HOVER = "hsl(240, 14%, 30%)";
export const BORDER_INTERACTIVE_SECONDARY_ACTIVE = "hsl(240, 14%, 38%)";
export const BORDER_INTERACTIVE_BOLD_DEFAULT = "hsl(240, 16%, 61%)";
export const BORDER_INTERACTIVE_BOLD_HOVER = "hsl(240, 17%, 80%)";
export const BORDER_INTERACTIVE_BOLD_ACTIVE = "hsl(240, 17%, 80%)";
export const BORDER_INTERACTIVE_FOCUS = "hsl(241, 86%, 63%)";
export const BORDER_DISABLED = "hsl(240, 14%, 38%)";
export const BORDER_ALERT_DANGER = "hsl(0, 65%, 55%)";
export const BORDER_ALERT_WARNING = "hsl(42, 100%, 37%)";
export const BORDER_ALERT_INFO = "hsl(216, 75%, 48%)";
export const BORDER_ALERT_SUCCESS = "hsl(110, 40%, 45%)";
export const BORDER_ALERT_BASIC = "hsl(240, 14%, 38%)";
export const LEGACY_SUPPORT_TAG_BACKGROUND_BASIC_BOLD = "hsl(240, 14%, 30%)";
export const LEGACY_SUPPORT_TAG_BACKGROUND_PRIMARY = "hsl(241, 91%, 26%)";
export const LEGACY_SUPPORT_TAG_BACKGROUND_DENIM = "hsl(212, 77%, 31%)";
export const LEGACY_SUPPORT_TAG_BACKGROUND_LIME = "hsl(123, 71%, 20%)";
export const LEGACY_SUPPORT_TAG_BACKGROUND_MUSTARD = "hsl(38, 91%, 45%)";
export const LEGACY_SUPPORT_TAG_BACKGROUND_LAVENDER = "hsl(252, 42%, 41%)";
export const LEGACY_SUPPORT_TAG_BACKGROUND_RUBY = "hsl(354, 76%, 42%)";
export const LEGACY_SUPPORT_TAG_BACKGROUND_TANGERINE = "hsl(15, 72%, 50%)";
export const LEGACY_SUPPORT_TAG_TEXT_BASIC_BOLD = "hsl(240, 17%, 80%)";
export const LEGACY_SUPPORT_TAG_TEXT_PRIMARY = "hsl(242, 89%, 83%)";
export const LEGACY_SUPPORT_TAG_TEXT_DENIM = "hsl(206, 47%, 93%)";
export const LEGACY_SUPPORT_TAG_TEXT_LIME = "hsl(125, 30%, 92%)";
export const LEGACY_SUPPORT_TAG_TEXT_MUSTARD = "hsl(0, 0%, 100%)";
export const LEGACY_SUPPORT_TAG_TEXT_LAVENDER = "hsl(258, 38%, 95%)";
export const LEGACY_SUPPORT_TAG_TEXT_RUBY = "hsl(350, 64%, 95%)";
export const LEGACY_SUPPORT_TAG_TEXT_TANGERINE = "hsl(0, 0%, 100%)";
export const LEGACY_SUPPORT_TAG_BORDER_BASIC_BOLD = "hsl(240, 16%, 61%)";
export const LEGACY_SUPPORT_TAG_BORDER_PRIMARY = "hsl(241, 86%, 63%)";
export const LEGACY_SUPPORT_TAG_BORDER_DENIM = "hsl(205, 47%, 52%)";
export const LEGACY_SUPPORT_TAG_BORDER_LIME = "hsl(125, 35%, 45%)";
export const LEGACY_SUPPORT_TAG_BORDER_MUSTARD = "hsl(45, 83%, 59%)";
export const LEGACY_SUPPORT_TAG_BORDER_LAVENDER = "hsl(255, 37%, 64%)";
export const LEGACY_SUPPORT_TAG_BORDER_RUBY = "hsl(350, 65%, 61%)";
export const LEGACY_SUPPORT_TAG_BORDER_TANGERINE = "hsl(20, 79%, 73%)";
export const PALETTE_BRAND_INDIGO_0 = "hsl(241, 100%, 10%)";
export const PALETTE_BRAND_INDIGO_25 = "hsl(241, 100%, 14%)";
export const PALETTE_BRAND_INDIGO_50 = "hsl(241, 96%, 18%)";
export const PALETTE_BRAND_INDIGO_100 = "hsl(241, 91%, 26%)";
export const PALETTE_BRAND_INDIGO_150 = "hsl(241, 86%, 34%)";
export const PALETTE_BRAND_INDIGO_200 = "hsl(241, 83%, 41%)";
export const PALETTE_BRAND_INDIGO_300 = "hsl(241, 75%, 48%)";
export const PALETTE_BRAND_INDIGO_400 = "hsl(241, 77%, 54%)";
export const PALETTE_BRAND_INDIGO_500 = "hsl(241, 82%, 58%)";
export const PALETTE_BRAND_INDIGO_600 = "hsl(241, 86%, 63%)";
export const PALETTE_BRAND_INDIGO_700 = "hsl(241, 88%, 72%)";
export const PALETTE_BRAND_INDIGO_800 = "hsl(242, 89%, 83%)";
export const PALETTE_BRAND_INDIGO_900 = "hsl(242, 90%, 92%)";
export const PALETTE_BRAND_NIGHT_0 = "hsl(240, 18%, 9%)";
export const PALETTE_BRAND_NIGHT_25 = "hsl(240, 17%, 10%)";
export const PALETTE_BRAND_NIGHT_50 = "hsl(240, 16%, 12%)";
export const PALETTE_BRAND_NIGHT_100 = "hsl(240, 15%, 16%)";
export const PALETTE_BRAND_NIGHT_150 = "hsl(240, 15%, 23%)";
export const PALETTE_BRAND_NIGHT_200 = "hsl(240, 14%, 30%)";
export const PALETTE_BRAND_NIGHT_300 = "hsl(240, 14%, 38%)";
export const PALETTE_BRAND_NIGHT_400 = "hsl(240, 13%, 45%)";
export const PALETTE_BRAND_NIGHT_500 = "hsl(240, 13%, 53%)";
export const PALETTE_BRAND_NIGHT_600 = "hsl(240, 16%, 61%)";
export const PALETTE_BRAND_NIGHT_700 = "hsl(240, 16%, 71%)";
export const PALETTE_BRAND_NIGHT_800 = "hsl(240, 17%, 80%)";
export const PALETTE_BRAND_NIGHT_900 = "hsl(240, 18%, 90%)";
export const PALETTE_BRAND_NIGHT_1000 = "hsl(0, 0%, 100%)";
export const PALETTE_BRAND_NIGHT_0_64 = "hsla(240, 18%, 9%, 0.64)";
export const PALETTE_BRAND_CORAL_0 = "hsl(356, 100%, 10%)";
export const PALETTE_BRAND_CORAL_25 = "hsl(356, 100%, 14%)";
export const PALETTE_BRAND_CORAL_50 = "hsl(356, 100%, 17%)";
export const PALETTE_BRAND_CORAL_100 = "hsl(356, 100%, 25%)";
export const PALETTE_BRAND_CORAL_150 = "hsl(356, 100%, 31%)";
export const PALETTE_BRAND_CORAL_200 = "hsl(356, 100%, 37%)";
export const PALETTE_BRAND_CORAL_300 = "hsl(356, 100%, 42%)";
export const PALETTE_BRAND_CORAL_400 = "hsl(356, 100%, 45%)";
export const PALETTE_BRAND_CORAL_500 = "hsl(356, 100%, 46%)";
export const PALETTE_BRAND_CORAL_600 = "hsl(356, 100%, 47%)";
export const PALETTE_BRAND_CORAL_700 = "hsl(356, 100%, 48%)";
export const PALETTE_BRAND_CORAL_800 = "hsl(356, 94%, 68%)";
export const PALETTE_BRAND_CORAL_900 = "hsl(356, 95%, 85%)";
export const PALETTE_BRAND_GREY_0 = "hsl(0, 0%, 7%)";
export const PALETTE_BRAND_GREY_25 = "hsl(0, 0%, 9%)";
export const PALETTE_BRAND_GREY_50 = "hsl(0, 0%, 12%)";
export const PALETTE_BRAND_GREY_100 = "hsl(0, 0%, 16%)";
export const PALETTE_BRAND_GREY_150 = "hsl(0, 0%, 21%)";
export const PALETTE_BRAND_GREY_200 = "hsl(0, 0%, 25%)";
export const PALETTE_BRAND_GREY_300 = "hsl(0, 0%, 35%)";
export const PALETTE_BRAND_GREY_400 = "hsl(0, 0%, 44%)";
export const PALETTE_BRAND_GREY_500 = "hsl(0, 0%, 53%)";
export const PALETTE_BRAND_GREY_600 = "hsl(0, 0%, 63%)";
export const PALETTE_BRAND_GREY_700 = "hsl(0, 0%, 72%)";
export const PALETTE_BRAND_GREY_800 = "hsl(0, 0%, 82%)";
export const PALETTE_BRAND_GREY_900 = "hsl(0, 0%, 91%)";
export const PALETTE_BRAND_GREY_1000 = "hsl(0, 0%, 100%)";
export const PALETTE_SEMANTIC_BLUE_0 = "hsl(216, 100%, 10%)";
export const PALETTE_SEMANTIC_BLUE_25 = "hsl(216, 100%, 14%)";
export const PALETTE_SEMANTIC_BLUE_50 = "hsl(216, 96%, 18%)";
export const PALETTE_SEMANTIC_BLUE_100 = "hsl(216, 91%, 26%)";
export const PALETTE_SEMANTIC_BLUE_150 = "hsl(216, 86%, 34%)";
export const PALETTE_SEMANTIC_BLUE_200 = "hsl(216, 83%, 41%)";
export const PALETTE_SEMANTIC_BLUE_300 = "hsl(216, 75%, 48%)";
export const PALETTE_SEMANTIC_BLUE_400 = "hsl(216, 77%, 54%)";
export const PALETTE_SEMANTIC_BLUE_500 = "hsl(216, 82%, 58%)";
export const PALETTE_SEMANTIC_BLUE_600 = "hsl(216, 86%, 63%)";
export const PALETTE_SEMANTIC_BLUE_700 = "hsl(216, 88%, 72%)";
export const PALETTE_SEMANTIC_BLUE_800 = "hsl(216, 89%, 83%)";
export const PALETTE_SEMANTIC_BLUE_900 = "hsl(216, 90%, 92%)";
export const PALETTE_SEMANTIC_ORANGE_0 = "hsl(42, 100%, 10%)";
export const PALETTE_SEMANTIC_ORANGE_25 = "hsl(43, 100%, 14%)";
export const PALETTE_SEMANTIC_ORANGE_50 = "hsl(42, 100%, 17%)";
export const PALETTE_SEMANTIC_ORANGE_100 = "hsl(42, 100%, 25%)";
export const PALETTE_SEMANTIC_ORANGE_150 = "hsl(42, 100%, 31%)";
export const PALETTE_SEMANTIC_ORANGE_200 = "hsl(42, 100%, 37%)";
export const PALETTE_SEMANTIC_ORANGE_300 = "hsl(42, 96%, 43%)";
export const PALETTE_SEMANTIC_ORANGE_400 = "hsl(42, 86%, 48%)";
export const PALETTE_SEMANTIC_ORANGE_500 = "hsl(42, 84%, 53%)";
export const PALETTE_SEMANTIC_ORANGE_600 = "hsl(42, 88%, 58%)";
export const PALETTE_SEMANTIC_ORANGE_700 = "hsl(42, 89%, 68%)";
export const PALETTE_SEMANTIC_ORANGE_800 = "hsl(42, 90%, 81%)";
export const PALETTE_SEMANTIC_ORANGE_900 = "hsl(42, 91%, 91%)";
export const PALETTE_SEMANTIC_GREEN_0 = "hsl(109, 46%, 14%)";
export const PALETTE_SEMANTIC_GREEN_25 = "hsl(110, 44%, 19%)";
export const PALETTE_SEMANTIC_GREEN_50 = "hsl(110, 44%, 24%)";
export const PALETTE_SEMANTIC_GREEN_100 = "hsl(110, 42%, 35%)";
export const PALETTE_SEMANTIC_GREEN_150 = "hsl(110, 40%, 45%)";
export const PALETTE_SEMANTIC_GREEN_200 = "hsl(110, 46%, 54%)";
export const PALETTE_SEMANTIC_GREEN_300 = "hsl(110, 59%, 62%)";
export const PALETTE_SEMANTIC_GREEN_400 = "hsl(110, 68%, 67%)";
export const PALETTE_SEMANTIC_GREEN_500 = "hsl(110, 74%, 71%)";
export const PALETTE_SEMANTIC_GREEN_600 = "hsl(110, 80%, 75%)";
export const PALETTE_SEMANTIC_GREEN_700 = "hsl(110, 81%, 81%)";
export const PALETTE_SEMANTIC_GREEN_800 = "hsl(110, 83%, 89%)";
export const PALETTE_SEMANTIC_GREEN_900 = "hsl(110, 85%, 95%)";
export const PALETTE_SEMANTIC_RED_0 = "hsl(0, 70%, 12%)";
export const PALETTE_SEMANTIC_RED_25 = "hsl(0, 68%, 16%)";
export const PALETTE_SEMANTIC_RED_50 = "hsl(0, 66%, 21%)";
export const PALETTE_SEMANTIC_RED_100 = "hsl(0, 64%, 31%)";
export const PALETTE_SEMANTIC_RED_150 = "hsl(0, 61%, 39%)";
export const PALETTE_SEMANTIC_RED_200 = "hsl(0, 59%, 47%)";
export const PALETTE_SEMANTIC_RED_300 = "hsl(0, 65%, 55%)";
export const PALETTE_SEMANTIC_RED_400 = "hsl(0, 74%, 60%)";
export const PALETTE_SEMANTIC_RED_500 = "hsl(0, 79%, 64%)";
export const PALETTE_SEMANTIC_RED_600 = "hsl(0, 84%, 69%)";
export const PALETTE_SEMANTIC_RED_700 = "hsl(0, 85%, 76%)";
export const PALETTE_SEMANTIC_RED_800 = "hsl(0, 86%, 85%)";
export const PALETTE_SEMANTIC_RED_900 = "hsl(0, 88%, 93%)";
export const PALETTE_DATAVIZ_DENIM_50 = "hsl(212, 77%, 31%)";
export const PALETTE_DATAVIZ_DENIM_100 = "hsl(209, 68%, 36%)";
export const PALETTE_DATAVIZ_DENIM_200 = "hsl(207, 64%, 39%)";
export const PALETTE_DATAVIZ_DENIM_300 = "hsl(206, 61%, 42%)";
export const PALETTE_DATAVIZ_DENIM_400 = "hsl(205, 59%, 44%)";
export const PALETTE_DATAVIZ_DENIM_500 = "hsl(205, 47%, 52%)";
export const PALETTE_DATAVIZ_DENIM_600 = "hsl(205, 46%, 61%)";
export const PALETTE_DATAVIZ_DENIM_700 = "hsl(205, 46%, 72%)";
export const PALETTE_DATAVIZ_DENIM_800 = "hsl(206, 47%, 83%)";
export const PALETTE_DATAVIZ_DENIM_900 = "hsl(206, 47%, 93%)";
export const PALETTE_DATAVIZ_LAVENDER_50 = "hsl(252, 42%, 41%)";
export const PALETTE_DATAVIZ_LAVENDER_100 = "hsl(254, 36%, 47%)";
export const PALETTE_DATAVIZ_LAVENDER_200 = "hsl(254, 33%, 51%)";
export const PALETTE_DATAVIZ_LAVENDER_300 = "hsl(255, 35%, 54%)";
export const PALETTE_DATAVIZ_LAVENDER_400 = "hsl(255, 37%, 57%)";
export const PALETTE_DATAVIZ_LAVENDER_500 = "hsl(255, 37%, 64%)";
export const PALETTE_DATAVIZ_LAVENDER_600 = "hsl(255, 37%, 70%)";
export const PALETTE_DATAVIZ_LAVENDER_700 = "hsl(255, 37%, 79%)";
export const PALETTE_DATAVIZ_LAVENDER_800 = "hsl(255, 36%, 87%)";
export const PALETTE_DATAVIZ_LAVENDER_900 = "hsl(258, 38%, 95%)";
export const PALETTE_DATAVIZ_LIME_50 = "hsl(123, 71%, 20%)";
export const PALETTE_DATAVIZ_LIME_100 = "hsl(124, 62%, 26%)";
export const PALETTE_DATAVIZ_LIME_200 = "hsl(125, 58%, 29%)";
export const PALETTE_DATAVIZ_LIME_300 = "hsl(125, 55%, 32%)";
export const PALETTE_DATAVIZ_LIME_400 = "hsl(125, 53%, 35%)";
export const PALETTE_DATAVIZ_LIME_500 = "hsl(125, 35%, 45%)";
export const PALETTE_DATAVIZ_LIME_600 = "hsl(126, 28%, 54%)";
export const PALETTE_DATAVIZ_LIME_700 = "hsl(125, 28%, 67%)";
export const PALETTE_DATAVIZ_LIME_800 = "hsl(126, 28%, 80%)";
export const PALETTE_DATAVIZ_LIME_900 = "hsl(125, 30%, 92%)";
export const PALETTE_DATAVIZ_MUSTARD_50 = "hsl(38, 91%, 45%)";
export const PALETTE_DATAVIZ_MUSTARD_100 = "hsl(41, 85%, 48%)";
export const PALETTE_DATAVIZ_MUSTARD_200 = "hsl(42, 82%, 49%)";
export const PALETTE_DATAVIZ_MUSTARD_300 = "hsl(44, 81%, 51%)";
export const PALETTE_DATAVIZ_MUSTARD_400 = "hsl(45, 83%, 52%)";
export const PALETTE_DATAVIZ_MUSTARD_500 = "hsl(45, 83%, 59%)";
export const PALETTE_DATAVIZ_MUSTARD_600 = "hsl(45, 83%, 66%)";
export const PALETTE_DATAVIZ_MUSTARD_700 = "hsl(45, 84%, 76%)";
export const PALETTE_DATAVIZ_MUSTARD_800 = "hsl(44, 84%, 86%)";
export const PALETTE_DATAVIZ_MUSTARD_900 = "hsl(45, 80%, 94%)";
export const PALETTE_DATAVIZ_TANGERINE_50 = "hsl(15, 72%, 50%)";
export const PALETTE_DATAVIZ_TANGERINE_100 = "hsl(17, 74%, 54%)";
export const PALETTE_DATAVIZ_TANGERINE_200 = "hsl(18, 76%, 57%)";
export const PALETTE_DATAVIZ_TANGERINE_300 = "hsl(19, 77%, 59%)";
export const PALETTE_DATAVIZ_TANGERINE_400 = "hsl(20, 79%, 61%)";
export const PALETTE_DATAVIZ_TANGERINE_500 = "hsl(20, 79%, 73%)";
export const PALETTE_DATAVIZ_TANGERINE_600 = "hsl(20, 79%, 73%)";
export const PALETTE_DATAVIZ_TANGERINE_700 = "hsl(20, 80%, 81%)";
export const PALETTE_DATAVIZ_TANGERINE_800 = "hsl(19, 80%, 88%)";
export const PALETTE_DATAVIZ_TANGERINE_900 = "hsl(20, 75%, 95%)";
export const PALETTE_DATAVIZ_RUBY_50 = "hsl(354, 76%, 42%)";
export const PALETTE_DATAVIZ_RUBY_100 = "hsl(352, 67%, 46%)";
export const PALETTE_DATAVIZ_RUBY_200 = "hsl(351, 63%, 49%)";
export const PALETTE_DATAVIZ_RUBY_300 = "hsl(350, 63%, 52%)";
export const PALETTE_DATAVIZ_RUBY_400 = "hsl(350, 65%, 54%)";
export const PALETTE_DATAVIZ_RUBY_500 = "hsl(350, 65%, 61%)";
export const PALETTE_DATAVIZ_RUBY_600 = "hsl(350, 65%, 68%)";
export const PALETTE_DATAVIZ_RUBY_700 = "hsl(350, 66%, 77%)";
export const PALETTE_DATAVIZ_RUBY_800 = "hsl(351, 66%, 86%)";
export const PALETTE_DATAVIZ_RUBY_900 = "hsl(350, 64%, 95%)";
export const PALETTE_BASICS_BLACK = "hsl(0, 0%, 0%)";
export const PALETTE_BASICS_WHITE = "hsl(0, 0%, 100%)";
export const PALETTE_BASICS_WHITE_64 = "hsla(0, 0%, 100%, 0.64)";
export const SHADOW_0 = "0px 0px 0px 0px hsl(0, 0%, 0%)";
export const SHADOW_100 = "0px 2px 6px -1px hsla(240, 18%, 9%, 0.08), 0px -1px 4px -2px hsla(240, 18%, 9%, 0.08)";
export const SHADOW_200 = "0px 8px 24px -4px hsla(240, 18%, 9%, 0.08), 0px 6px 12px -6px hsla(240, 18%, 9%, 0.08)";
export const SHADOW_300 = "0px 18px 88px -4px hsla(240, 18%, 9%, 0.12), 0px 12px 28px -6px hsla(240, 18%, 9%, 0.12)";
export const FOCUS_OFFSET = "0px 0px 0px 2px hsl(0, 0%, 100%), 0px 0px 0px 4px hsl(241, 86%, 63%)";
export const FONT_SIZE_RATIO = 1.125;
export const FONT_SIZE_50 = 11;
export const FONT_SIZE_75 = 12;
export const FONT_SIZE_100 = 14;
export const FONT_SIZE_200 = 16;
export const FONT_SIZE_300 = 18;
export const FONT_SIZE_400 = 20;
export const FONT_SIZE_500 = 22;
export const FONT_SIZE_600 = 25;
export const FONT_SIZE_700 = 28;
export const FONT_SIZE_800 = 32;
export const FONT_SIZE_900 = 36;
export const FONT_SIZE_BASE = 14;
export const FONT_FAMILY_UI = "Inter";
export const FONT_WEIGHT_300 = 300;
export const FONT_WEIGHT_400 = 400;
export const FONT_WEIGHT_500 = 500;
export const FONT_WEIGHT_600 = 600;
export const LINE_HEIGHT_100 = 1;
export const LINE_HEIGHT_200 = 1.3;
export const LINE_HEIGHT_300 = 1.5;
export const LETTER_SPACING_CONDENSED = "-0.2px";
export const LETTER_SPACING_DEFAULT = 0;
export const LETTER_SPACING_WIDE = "0.2px";
export const TEXT_DECORATION_UNDERLINE = "underline";
export const HIGHLIGHT_L = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.3,"fontSize":36,"letterSpacing":"-0.2px"};
export const HIGHLIGHT_M = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.3,"fontSize":28,"letterSpacing":"-0.2px"};
export const HIGHLIGHT_S = {"fontFamily":"Inter","fontWeight":600,"lineHeight":1.3,"fontSize":18,"letterSpacing":0};
export const TITLE_L = {"fontFamily":"Inter","fontWeight":600,"lineHeight":1.5,"fontSize":22,"letterSpacing":0};
export const TITLE_M = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.5,"fontSize":20,"letterSpacing":0};
export const TITLE_S = {"fontFamily":"Inter","fontWeight":600,"lineHeight":1.3,"fontSize":18,"letterSpacing":0};
export const BODY_L = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":16,"letterSpacing":0};
export const BODY_L_STRONG = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.5,"fontSize":16,"letterSpacing":0};
export const BODY_L_UNDERLINED = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":16,"textDecoration":"underline","letterSpacing":0};
export const BODY_L_STRONG_UNDERLINED = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.5,"fontSize":16,"textDecoration":"underline","letterSpacing":0};
export const BODY_M = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":14,"letterSpacing":0};
export const BODY_M_STRONG = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.5,"fontSize":14,"letterSpacing":0};
export const BODY_M_UNDERLINED = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":14,"letterSpacing":0,"textDecoration":"underline"};
export const BODY_M_STRONG_UNDERLINED = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.5,"fontSize":14,"letterSpacing":0,"textDecoration":"underline"};
export const BODY_S = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":12,"letterSpacing":0};
export const BODY_S_STRONG = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.5,"fontSize":12,"letterSpacing":0};
export const BODY_S_UNDERLINED = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":12,"letterSpacing":0,"textDecoration":"underline"};
export const BODY_S_STRONG_UNDERLINED = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.5,"fontSize":12,"letterSpacing":0,"textDecoration":"underline"};
export const BODY_XS = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1,"fontSize":11,"letterSpacing":"0.2px"};
export const BODY_XS_STRONG = {"fontFamily":"Inter","fontWeight":600,"lineHeight":1,"fontSize":11,"letterSpacing":"0.2px"};
export const BODY_XS_UNDERLINED = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1,"fontSize":11,"letterSpacing":"0.2px","textDecoration":"underline"};
export const SPACING_0 = 0;
export const SPACING_25 = 2;
export const SPACING_50 = 4;
export const SPACING_100 = 8;
export const SPACING_150 = 12;
export const SPACING_200 = 16;
export const SPACING_250 = 20;
export const SPACING_300 = 24;
export const SPACING_400 = 32;
export const SPACING_450 = 36;
export const SPACING_500 = 40;
export const SPACING_700 = 56;
export const SPACING_900 = 72;
export const SPACING_1200 = 96;
export const BORDER_RADIUS_0 = 0;
export const BORDER_RADIUS_25 = 2;
export const BORDER_RADIUS_50 = 4;
export const BORDER_RADIUS_100 = 8;
export const BORDER_RADIUS_200 = 16;
export const BORDER_RADIUS_300 = 24;
export const BORDER_RADIUS_ROUND = "50%";
export const BORDER_RADIUS_BASE = 8;
export const SPACING_BASE = 8;
export const BORDER_WIDTH_0 = 0;
export const BORDER_WIDTH_100 = 1;
export const BORDER_WIDTH_150 = 1.5;
export const BORDER_WIDTH_200 = 2;
export const BORDER_WIDTH_250 = 2.5;
export const BORDER_WIDTH_300 = 3;
export const BORDER_STYLE_SOLID_STYLE = "solid";
export const BORDER_STYLE_DOTTED_STYLE = "dashed";
export const SIZING_BASE = 8;
export const SIZING_200 = 16;
export const SIZING_300 = 24;
export const SIZING_400 = 32;
export const SIZING_500 = 40;
export const SIZING_550 = 44;
export const SIZING_600 = 48;
export const SIZING_900 = 72;
export const OPACITY_0 = "0%";
export const OPACITY_100 = "8%";
export const OPACITY_150 = "12%";
export const OPACITY_200 = "16%";
export const OPACITY_400 = "32%";
export const OPACITY_600 = "48%";
export const OPACITY_800 = "64%";
export const OPACITY_1000 = "100%";